(function($){

    /**
     * Function that applies a custom style layer to google map.
     * Each country is assigned the color set in the array colorAssociated
     *
     * @param map
     * @param filledCountries
     * @return object
     */
    function setStyle(map, filledCountries) {

        /**
         * array containing all the countries of the world.
         * Each state must be assigned a color that is different from neighboring countries
         * Possible colors = ['#B1D8A2', '#8ABC69', '#0DBC98', '#FCE200', '#FCB900', #889D2F, '#3bada2' ]
         *
         *  !!! color to be decided for other (unused) countries !!!
         */

        var colorAssociated = {
            // 'Afghanistan': 'Afghanistan',
            // 'Åland': 'Åland',
            Albania: '#B1D8A2',
            Algeria: '#0DBC98',
            // American Samoa': American Samoa',
            Andorra: '#FCB900',
            // 'Angola': 'Angola',
            // 'Anguilla': 'Anguilla',
            // 'Antigua and Barbuda': 'Antigua and Barbuda',
            // 'Argentina': 'Argentina',
            'Armenia': '#FCB900',
            // 'Aruba': 'Aruba',
            // 'Ashmore and Cartier Islands': 'Ashmore and Cartier Islands',
            // 'Australia': 'Australia',
            // 'Australian Indian Ocean Territories': 'Australian Indian Ocean Territories',
            'Austria': '#0DBC98',
            // 'Azerbaijan': 'Azerbaijan',
            // 'Bahrain': 'Bahrain',
            // 'Bangladesh': 'Bangladesh',
            // 'Barbados': 'Barbados',
            'Belarus': '#FCE200',
            'Belgium': '#889D2F',
            // 'Belize': 'Belize',
            // 'Benin': 'Benin',
            // 'Bermuda': 'Bermuda',
            // 'Bhutan': 'Bhutan',
            // 'Bolivia': 'Bolivia',
            'Bosnia and Herzegovina': '#0DBC98',
            // 'Botswana': 'Botswana',
            // 'Brazil': 'Brazil',
            // 'British Virgin Islands': 'British Virgin Islands',
            // 'Brunei': 'Brunei',
            'Bulgaria': '#FCE200',
            // 'Burkina Faso': 'Burkina Faso',
            // 'Burundi': 'Burundi',
            // 'Cambodia': 'Cambodia',
            // 'Cameroon': 'Cameroon',
            // 'Canada': 'Canada',
            // 'Cape Verde': 'Cape Verde',
            // 'Cayman Islands': 'Cayman Islands',
            // 'Central African Republic': 'Central African Republic',
            // 'Chad': 'Chad',
            // 'Chile': 'Chile',
            // 'Colombia': 'Colombia',
            // 'Comoros': 'Comoros',
            'Cook Islands': '#FCB900',
            // 'Costa Rica': 'Costa Rica',
            'Croatia': '#889D2F',
            // 'Cuba': 'Cuba',
            // 'Curaçao': 'Curaçao',
            'Cyprus': '#FCB900',
            'Czech Republic': '#3bada2',
            // 'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
            'Denmark': '#FCB900',
            // 'Djibouti': 'Djibouti',
            'Dominica': '#FCB900',
            // 'Dominican Republic': 'Dominican Republic',
            // 'East Timor': 'East Timor',
            // 'Ecuador': 'Ecuador',
            'Egypt': '#FCB900',
            // 'El Salvador': 'El Salvador',
            // 'Equatorial Guinea': 'Equatorial Guinea',
            // 'Eritrea': 'Eritrea',
            'Estonia': '#FCB900',
            // 'Eswatini': 'Eswatini',
            // 'Ethiopia': 'Ethiopia',
            'Falkland Islands': '#FCB900',
            // 'Faroe Islands': 'Faroe Islands',
            // 'Federated States of Micronesia': 'Federated States of Micronesia',
            // 'Fiji': 'Fiji',
            'Finland': '#8ABC69',
            'France': '#B1D8A2',
            // 'French Polynesia': 'French Polynesia',
            // 'Gabon': 'Gabon',
            // 'Georgia': 'Georgia',
            'Germany': '#8ABC69',
            // 'Ghana': 'Ghana',
            'Greece': '#8ABC69',
            // 'Greenland': 'Greenland',
            // 'Grenada': 'Grenada',
            // 'Guam': 'Guam',
            // 'Guatemala': 'Guatemala',
            // 'Guernsey': 'Guernsey',
            // 'Guinea': 'Guinea',
            // 'Guinea-Bissau': 'Guinea-Bissau',
            // 'Guyana': 'Guyana',
            // 'Haiti': 'Haiti',
            // 'Honduras': 'Honduras',
            // 'Hong Kong': 'Hong Kong',
            'Hungary': '#FCE200',
            'Iceland': '#B1D8A2',
            // 'India': 'India',
            // 'Indonesia': 'Indonesia',
            'Iran': '#3bada2',
            'Iraq': '#FCB900',
            'Ireland': '#8ABC69',
            'Isle of Man': '#FCB900',
            // 'Israel': 'Israel',
            'Italy': '#8ABC69',
            // 'Ivory Coast': 'Ivory Coast',
            // 'Jamaica': 'Jamaica',
            // 'Japan': 'Japan',
            // 'Jersey': 'Jersey',
            // 'Jordan': 'Jordan',
            'Kazakhstan': '#8ABC69',
            // 'Kenya': 'Kenya',
            // 'Kiribati': 'Kiribati',
            'Kosovo': '#B1D8A2',
            // 'Kuwait': 'Kuwait',
            'Kyrgyzstan': '#FCB900',
            // 'Laos': 'Laos',
            'Latvia': '#FCB900',
            // 'Lebanon': 'Lebanon',
            // 'Lesotho': 'Lesotho',
            // 'Liberia': 'Liberia',
            // 'Libya': 'Libya',
            'Liechtenstein': '#FCB900',
            'Lithuania': '#8ABC69',
            'Luxembourg': '#B1D8A2',
            // 'Macau': 'Macau',
            // 'Madagascar': 'Madagascar',
            // 'Malawi': 'Malawi',
            // 'Malaysia': 'Malaysia',
            // 'Mali': 'Mali',
            'Malta': '#8ABC69',
            // 'Marshall Islands': 'Marshall Islands',
            // 'Mauritania': 'Mauritania',
            // 'Mexico': 'Mexico',
            'Moldova': '#FCB900',
            'Monaco': '#8ABC69',
            // 'Mongolia': 'Mongolia',
            'Montenegro': '#FCB900',
            // 'Montserrat': 'Montserrat',
            // 'Morocco': 'Morocco',
            // 'Mozambique': 'Mozambique',
            // 'Myanmar': 'Myanmar',
            // 'Namibia': 'Namibia',
            // 'Nauru': 'Nauru',
            // 'Nepal': 'Nepal',
            'Netherlands': '#0DBC98',
            // 'New Caledonia': 'New Caledonia',
            // 'New Zealand': 'New Zealand',
            // 'Nicaragua': 'Nicaragua',
            // 'Niger': 'Niger',
            // 'Nigeria': 'Nigeria',
            // 'Niue': 'Niue',
            'Norfolk Island': '#B1D8A2',
            // 'North Korea': 'North Korea',
            'North Macedonia': '#FCB900',
            // 'Northern Mariana Islands': 'Northern Mariana Islands',
            'Norway': '#0DBC98',
            // 'Oman': 'Oman',
            'Pakistan': '#FCB900',
            // 'Palau': 'Palau',
            'Palestine': '#FCB900',
            // 'Panama': 'Panama',
            // 'Papua New Guinea': 'Papua New Guinea',
            // 'Paraguay': 'Paraguay',
            // 'People\'s Republic of China': 'People\'s Republic of China',
            // 'Peru': 'Peru',
            // 'Philippines': 'Philippines',
            // 'Pitcairn Islands': 'Pitcairn Islands',
            'Poland': '#889D2F',
            'Portugal': '#3bada2',
            // 'Puerto Rico': 'Puerto Rico',
            'Qatar': '#FCB900',
            // 'Republic of the Congo': 'Republic of the Congo',
            'Romania': '#B1D8A2',
            'Russia': '#B1D8A2',
            // 'Rwanda': 'Rwanda',
            // 'Saint Barthélemy': 'Saint Barthélemy',
            // 'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
            // 'Saint Lucia': 'Saint Lucia',
            // 'Saint Martin': 'Saint Martin',
            // 'Saint Pierre and Miquelon': 'Saint Pierre and Miquelon',
            // 'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
            // 'Samoa': 'Samoa',
            'San Marino': '#FCB900',
            // 'Saudi Arabia': 'Saudi Arabia',
            // 'Senegal': 'Senegal',
            'Serbia': '#FCB900',
            // 'Siachen Glacier': 'Siachen Glacier',
            // 'Sierra Leone': 'Sierra Leone',
            // 'Singapore': 'Singapore',
            // 'Sint Maarten': 'Sint Maarten',
            'Slovakia': '#FCB900',
            'Slovenia': '#FCB900',
            // 'Solomon Islands': 'Solomon Islands',
            // 'Somalia': 'Somalia',
            // 'Somaliland': 'Somaliland',
            // 'South Africa': 'South Africa',
            // 'South Korea': 'South Korea',
            // 'South Sudan': 'South Sudan',
            'Spain': '#0DBC98',
            // 'Sri Lanka': 'Sri Lanka',
            // 'Sudan': 'Sudan',
            // 'Suriname': 'Suriname',
            'Sweden': '#889D2F',
            'Switzerland': '#FCB900',
            // 'Syria': 'Syria',
            // 'São Tomé and Príncipe': 'São Tomé and Príncipe',
            // 'Taiwan': 'Taiwan',
            // 'Tajikistan': 'Tajikistan',
            // 'Tanzania': 'Tanzania',
            // 'Thailand': 'Thailand',
            // 'The Bahamas': 'The Bahamas',
            // 'The Gambia': 'The Gambia',
            // 'Togo': 'Togo',
            // 'Tonga': 'Tonga',
            // 'Trinidad and Tobago': 'Trinidad and Tobago',
            'Tunisia': '#FCB900',
            'Turkey': '#8ABC69',
            // 'Turkish Republic of Northern Cyprus': 'Turkish Republic of Northern Cyprus',
            // 'Turkmenistan': 'Turkmenistan',
            // 'Turks and Caicos Islands': 'Turks and Caicos Islands',
            // 'Tuvalu': 'Tuvalu',
            // 'Uganda': 'Uganda',
            'Ukraine': '#3bada2',
            // 'United Arab Emirates': 'United Arab Emirates',
            'United Kingdom': '#FCB900',
            // 'United States Virgin Islands': 'United States Virgin Islands',
            // 'United States of America': 'United States of America',
            // 'Uruguay': 'Uruguay',
            // 'Uzbekistan': 'Uzbekistan',
            // 'Vanuatu': 'Vanuatu',
            'Vatican City': '#FCB900',
            // 'Venezuela': 'Venezuela',
            // 'Vietnam': 'Vietnam',
            // 'Wallis and Futuna': 'Wallis and Futuna',
            // 'Western Sahara': 'Western Sahara',
            // 'Yemen': 'Yemen',
            // 'Zambia': 'Zambia',
            // 'Zimbabwe': 'Zimbabwe',
        };

        map.data.setStyle(function (feature) {
            var country = feature.getProperty('name_en');
            var color = 'transparent';
            var strokeWeight = 1;
            var strokeColor = 'transparent';
            var zIndex = 100;
            if (feature.getProperty('featureclass') === 'Ocean') {
                strokeWeight = 4;
                strokeColor = '#C8EFEF';
                zIndex = 1;
            }
            for (var i = 0; i < filledCountries.length; i++) {
                if (country === filledCountries[i]) {
                    color = colorAssociated[country];
                    strokeColor = '#0D4C4D';
                }
            }
            return {
                zIndex: zIndex,
                fillColor: color,
                strokeWeight: strokeWeight,
                strokeColor: strokeColor,
                fillOpacity: 1
            };
        });
    }

    function greet_initializeMapGroup(div){
        /** define gmap and bounds **/
        if (typeof(div) === "undefined") div = "map-canvas";
        if (typeof(bounds) === "undefined" && map_config.set_bounds) bounds = new google.maps.LatLngBounds();

        var marker, i;
        var center = (map_config.markers !== undefined)? [map_config.markers[0].latitude, map_config.markers[0].longitude] : [47.74571672139669, 2.982376857176733]; //france

        map = new google.maps.Map(document.getElementById(div), {
            // scroll wheel
            scrollwheel: false,
            //zoom
            zoom: 12,
            // zoom: map_config.map_zoom,
            zoomControlOptions: {
                position: google.maps.ControlPosition[map_config.zoom_control_position]
            },
            //position
            center: new google.maps.LatLng(center[0], center[1]),
            //map type
            mapTypeId: google.maps.MapTypeId[map_config.map_type],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            panControl: false,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            scaleControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            }

        });

        /**  easily import GeoJSON data and display points, line-strings and polygons
         *  used to draw country borders and oceans on the stylized map
         **/
        map.data.loadGeoJson(theme_url +"/js/all.geo.json");
        map.data.loadGeoJson(theme_url + "/js/ocean.geojson");
        var customMapStyle = [{"featureType": "all", "elementType": "all", "stylers": [{"color": "#0d4c4d"}]}, {"featureType": "administrative", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#B3E8E9"}]}];
        var defaultMapStyle = [{"featureType": "poi.business", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#B3E8E9"}]}];

        map.setOptions({styles: customMapStyle});

        /** Assign colors to highlighted countries -> with at least one CPT hotel published **/
        setStyle(map, window.filledCountries);

        /** Define, based on the zoom of the map, whether to show the stylized layer
         * map zoom > 6  = default map style
         * map zoom <= 6  = custom/colored  map style
         **/
        var visible = true;
        google.maps.event.addListener(map, 'zoom_changed', function () {
            var zoom = map.getZoom();
            if (zoom > 6) {
                visible = false;
                map.data.setStyle({visible: false});
                map.setOptions({styles: defaultMapStyle});

            } else if (visible === false) {
                visible = true;
                map.setOptions({styles: customMapStyle});

                setStyle(map, window.filledCountries);
            }
        });

        /** add all the hotels as markers,
         * with relative info window that can be opened with a click
         **/
        if(map_config.markers !== undefined){
            for (i = 0; i < map_config.markers.length; i++) {
                var infowindow = new google.maps.InfoWindow();
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(map_config.markers[i].latitude, map_config.markers[i].longitude),
                    map: map,
                    icon : {
                        url		: map_config.markers[i].icon_hotel,
                        scaledSize: new google.maps.Size(80, 50) // height , width
                    },
                    id_poi: map_config.markers[i].id_poi.toString(),
                    poi_title: map_config.markers[i].title.toString(),
                    html: map_config.markers[i].html,
                    destination: map_config.markers[i].destination.toString(),
                    zIndex: 0,
                    tabIndex: 0,
                    visible: true
                });

                markers[map_config.markers[i].id_poi] = marker;

                bounds.extend(marker.position);

                //infowindow
                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {

                        map.setCenter(marker.getPosition());

                        if (window.hotel_infowindow) {
                            window.hotel_infowindow.close();
                        }
                        if (infowindow) {
                            infowindow.close();
                        }
                        infowindow.setContent(marker.html);
                        infowindow.open(map, marker);
                        var infobox_map = $('.infobox_map');
                        if (infobox_map.length > 0 && !window.is_mobile) {
                            infobox_map.fadeOut();
                        }
                        google.maps.event.addListenerOnce(infowindow, 'closeclick', function () {
                            if (infobox_map.length > 0 && !window.is_mobile) {
                                infobox_map.fadeIn();
                            }
                        });

                    };
                })(marker, i));
            }

        }



        /** Define, based on the zoom of the map, whether to show the stylized layer
         * map zoom > 6  = default map style
         * map zoom <= 6  = custom/colored  map style
         **/
        var clusterStyles = [{
            textColor: '#000',
            url: theme_url + '/css/images/cluster.svg',
            height: 45,
            width: 45,
            textSize: 16,
            tabIndex: 0,
        }];

        var numeric_array = [];
        for ( var item in markers ){
            numeric_array.push( markers[ item ] );
        }

        var markerCluster = new MarkerClusterer(map, numeric_array, {styles: clusterStyles});
        markerCluster.setGridSize(50);

        map.maxDefaultZoom = 5;

        google.maps.event.addListenerOnce(map, "bounds_changed", function () {
            this.setZoom(this.maxDefaultZoom);
        });

        map.fitBounds(bounds);

        $('button[title="Keyboard shortcuts"] , .gmnoprint a, .gm-style-cc a').attr('tabindex', -1);

    }


    /** When there is a change in the bounce, set a maximum zoom level, in order not to get a too zoomed map
     * map.maxDefaultZoom
     **/
    function setMaxZoom(){
        google.maps.event.addListenerOnce(map, "bounds_changed", function () {
            this.setZoom(this.maxDefaultZoom);
        });
    }

    /** Function to center the map with all visible markers (hotels)
     *  set maxDefaultZoom
     **/
    function defaultZoom(){
        var marker = map_config.markers[i];
        if (typeof(boundsAll) === "undefined" && map_config.set_bounds) boundsAll = new google.maps.LatLngBounds();

        if(map_config.markers !== undefined) {
            for (var i = 0; i < map_config.markers.length; i++) {
                var marker_pos = new google.maps.LatLng(marker.latitude, marker.longitude);
                boundsAll.extend(marker_pos);
            }
        }
        map.maxDefaultZoom = 5;
        setMaxZoom();

        map.fitBounds(boundsAll);
    }


    /** Function to center the map when clicking a Country in the map select.
     * Only markers (hotels) belonging to that country are taken and displayed.
     **/
    function zoomCountry(category){
        if (typeof(boundsCountry) === "undefined" && map_config.set_bounds) boundsCountry = new google.maps.LatLngBounds();

        if(map_config.markers !== undefined) {
            for (var i = 0; i < map_config.markers.length; i++) {
                var marker = map_config.markers[i];
                if (marker.country.toString() === category) {
                    var marker_pos = new google.maps.LatLng(marker.latitude, marker.longitude);
                    boundsCountry.extend(marker_pos);
                }
            }
        }
        map.maxDefaultZoom = 6;
        setMaxZoom();

        map.fitBounds(boundsCountry);
    }

    function zoomDestination(category){
        if (typeof(boundsDestination) === "undefined" && map_config.set_bounds) boundsDestination = new google.maps.LatLngBounds();

        if(map_config.markers !== undefined) {
            for (var i = 0; i < map_config.markers.length; i++) {
                var marker = map_config.markers[i];

                if (marker.destination.includes(parseInt(category))) {
                    var marker_pos = new google.maps.LatLng(marker.latitude, marker.longitude);
                    boundsDestination.extend(marker_pos);
                }
            }
        }
        map.maxDefaultZoom = 11;
        setMaxZoom();

        map.fitBounds(boundsDestination);
    }
    function zoomHotel(category){

        var marker = map_config.markers.filter(obj => {
            console.log(obj);
            return obj.id_poi === parseInt(category)
        });
        marker = marker[0];

        map.maxDefaultZoom = 13;
        setMaxZoom();

        var marker_pos = new google.maps.LatLng(marker.latitude, marker.longitude);
        map.setCenter(marker_pos);

        //open infowindow
        google.maps.event.trigger(markers[marker.id_poi], 'click');

        setTimeout(function(){
            var divHeightOfTheMap = document.getElementById('map-canvas').clientHeight;

            map.panBy(0, -(divHeightOfTheMap / 5 ));
        }, 200);
    }



    $(document).ready(function () {

        var map_loaded = false;
        if ($('#map-canvas').length === 0) return false;

        var position_map = $('#map-canvas').offset().top - $('#map-canvas').height() - 200;

        $(window).on("scroll", function() {
            var scrollPosition = window.pageYOffset;
            if(!map_loaded && scrollPosition >= position_map){
                map_loaded = true;
                greet_initializeMapGroup();
            }
        });

        var select_destinations = $('#select_destinations_map');
        select_destinations.on('change', function(){
            // var value = $(this).val();

            var country = $(this).find('option:selected').attr('data-country');
            var destination = $(this).find('option:selected').attr('data-destination');
            var hotel = $(this).find('option:selected').attr('data-hotel');

            if(country !== undefined){
                zoomCountry(country);
            } else if(destination !== undefined){
                zoomDestination(destination);
            } else if(hotel !== undefined){
                zoomHotel(hotel);
            } else {
                defaultZoom();
            }

        })

    });

})(jQuery);